export enum FeatureFlagValue {
  On = "true",
  Off = "false",
}

// There are additional flags defined in CCS, but none of them are utilized in the FE code
export enum FeatureFlagName {
  FTE39139EnableContentSharingFastFollows = "FTE-39139_enableContentSharingFastFollows",
  FTE30785EnableSharedWorkspaceProjectType = "FTE-30785_enableSharedWorkspaceProjectType",
  FTE35848EnableInlineHAQForGRR = "FTE-35848_enableInlineHAQForGRR",
  FTE40175EnableInlineHAQForReliance = "FTE-40175_enableInlineHAQForReliance",
  FTE40791EnableInReviewStatusForRelianceDocuments = "FTE-40791_enableInReviewStatusForRelianceDocuments",
  FTE42534EnableInitiateWorkspaceForHA = "FTE-42534_enableInitiateWorkspaceForHA",
  ShowTranslateMenu = "FTE-5071-showTranslateMenu",
  FTE43012EnableInvitationsCancellation = "FTE-43012-enableInvitationsCancellation",
  FTE29097EnableMultitenancyPhase2 = "FTE-29097_enableMultitenancyPhase2",
  EnableDetailedShareHistory = "enableDetailedShareHistory",
  FTE35826EnableHAQCreationForSponsor = "FTE-35826-enableHAQCreationForSponsor",
  FTE36741EnableInReviewStatusForGRRDocuments = "FTE-36741_enableInReviewStatusForGRRDocuments",
  FTE38185EnableInReviewStatusForECTD = "FTE-38185_enableInReviewStatusForECTD",
  FTE34019MemberManagementTaskChangeNotifications = "FTE-34019_memberManagementTaskChangeNotifications",
  FTE42084EnableInlineCommentingForReliancePDF = "FTE-42084-enableInLineCommentingForReliance",
  FTE40812EnableInlineCommentingForGRRECTD = "FTE-40812_enableInLineCommentingForGRReCTD",
  FTE40812EnableInlineCommentingForRelianceECTD = "FTE-40812_enableInLineCommentingForRelianceeCTD",
  FTE42752EnableRefreshParticipantsTable = "FTE-42752-enableRefreshParticipantsTable",
  FTE43709EnableInLineHAQFilterForGRR = "FTE-43709_enableInLineHAQFilterForGRR",
  FTE33876EnableSanitizeFileUploading = "FTE-33876_enableSanitizeFileUploading",
  FTE44097EnablePDFToolbarForECTD = "FTE-44097_enablePDFToolbarForECTD",
  FTE40684EnablePDFZoom = "FTE-40684_enablePDFZoom",
  FTE41565DisableContentAutoSubmitOnInvitation = "FTE-41565-disableContentAutoSubmitOnInvitation",
  FTE42849EnablePDDFStructuredContent = "FTE-42849_enablePDDFStructuredContent",
  FTE42684EnableInlineHAQForECTD = "FTE-42684_enableInlineHAQForECTD",
  EnableExternalUserCreation = "FTE-44823-enableExternalUser",
  EnableMultipleFileUpload = "FTE-42869-enableMultipleFileUpload",
  EnableRenameProductToEntity = "FTE-47958-enableRenameProductToEntity",
  EnableBulkInvitations = "FTE-43337-enableBulkInvitations",
  EnableEmailGroupNotifications = "FTE-51559-enableEmailGroupNotifications",
  EnableStructuredDocumentTransitionToFinal = "FTE-44487_enablePDDFVersionControl",
  EnableStructuredDocumentVersionChange = "FTE-44450-enableStructuredDocumentVersionChange",
  SubmittingDossier = "FTE-49282-submittingDossier",
  Enable10GBECTD = "FTE-43019-file-size-50", // changed after creation from 50GB to 10GB
  EnableDeletingColumnsForProjectMembers = "FTE-51624-enableDeletingColumnsForMemberTab",
  EnableEmailGroupContentAndQuestions = "FTE-51988-enableEmailGroupContentAndQuestions",
  EnableProjectDeletion = "FTE-50707_enableProjectDeletion",
  EnableHAQAttachmentsAutoSubmitEnhancements = "FTE-52211-enableAutoSubmitEnhancements",
  EnableMultipleStructuredDocuments = "FTE-52954-enableMultipleStructuredDocuments",
  EnableHAEditDecision = "FTE-53269-enableHAToLogDecisions",
  EnableAdminConfigurations = "FTE-41713-enableAdminConfigurations",
  EnableUpdatedContentStatusField = "FTE-52527-enableUpdatedContentStatusField",
  EnableShareHistoryForStructuredDocument = "FTE-49001-enableShareHistoryForStructuredDocument",
  EnableEmailGroupTaskManagement = "FTE-49819-enableNrtEmailsTaskManagement",
  EnableEditStructureDocumentSectionTitle = "FTE-54155-enableEditStructuredDocumentSections",
  EnableMultipleDocsInStructuredDocSection = "FTE-52754-enableMultipleDocsInStructuredDocSection",
  EnableDeleteStructuredDocSection = "FTE-44276-enableDeleteStructuredDocSection",
  EnableEmailGroupMilestones = "FTE-55113-enableMilestoneEmails",
  EnableNewInLineUIEnhancements = "FTE-52967-enableNewInLineUIEnhancements",
  EnableNestedSectionsInStructuredDocuments = "FTE-55589-enableNestedSectionsInStructuredDocuments",
  EnableNewParticipantsEndpoint = "FTE-55534-new-participants-endpoint",
}
